import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

const AuthenticatedRoute = (props) => {
  const { user } = useSelector((state) => state.auth);
  // const userRoute = (
  //   <props.Component history={props.history} location={props.location} match={props.match} />
  // );

  let userRoute;

  if (user) {
    userRoute = (
      <props.Component history={props.history} location={props.location} match={props.match} />
    );
  } else {
    userRoute = (
      <Redirect
        to={{
          pathname: '/login',
          state: { referrer: props.location.pathname }
        }}
      />
    );
  }
  return userRoute;
};

export default AuthenticatedRoute;
